
























import { Vue, Component, Watch } from "vue-property-decorator";
import ActivityNote from "@/components/Sidebar/Activity/ActivityNote.vue";
import Customer from "@/components/Sidebar/Customer/Customer.vue";
import { CustomerSchema } from "../../../models/customer_schema";
import CustomerService from "@/services/customer_service";
import { StoreModule } from "@/store/types";
import {
  CustomerActions,
  CustomerGetters,
} from "@/store/modules/customer/types";
import { namespace } from "vuex-class";
import { ActivitySchema } from "@/models/activity_schema";
import moment from "moment";
import { AuthError, APIError, GenericError } from "@/services/error_service";
import simplebar from "simplebar-vue";
import { SalesContactSchema } from "@/models/sales_contact_schema";
import { EventBus } from "@/events";
import { GlobalActions } from "@/store/modules/global/types";

@Component({
  components: {
    Customer,
    ActivityNote,
    simplebar,
  },
})
export default class SingleCustomer extends Vue {
  protected selectedCustomerId!: string;
  protected customerService = new CustomerService();
  protected notes = [] as ActivitySchema[];
  protected contacts = [] as SalesContactSchema[];
  @(namespace(StoreModule.Customer).Action(CustomerActions.FetchSingleCustomer))
  fetchSingleCustomer;
  @(namespace(StoreModule.Customer).Getter(CustomerGetters.GetSelected))
  selectedCustomer;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddLoading)) setLoading;
  created() {
    this.selectedCustomerId = this.$route.params.id.trim();
    this.getCustomer();
    this.fetchActivityNotes();
  }

  mounted() {
    EventBus.$on("updateCustomer", () => this.getCustomer());
  }

  beforeDestroy() {
    EventBus.$off("updateCustomer");
  }

  @Watch("$route.params.id")
  protected onChange(): void {
    if (this.$route.params.id) {
      this.selectedCustomerId = this.$route.params.id.trim();
      this.getCustomer();
      this.fetchActivityNotes();
    }
  }

  public async getCustomer(): Promise<void> {
    this.setLoading(true);
    try {
      const res = await this.fetchSingleCustomer(this.selectedCustomerId);
      this.contacts = res.sales_contacts ? res.sales_contacts : [];
    } catch (err) {
      this.setLoading(false);
      if (err instanceof AuthError) {
        AuthError.logout();
      } else {
        // do a redirect if not being sent to login screen. fetchSingleCustomer store action has other error handling
        this.$router.replace({ path: "/customers" }).catch((err) => {});
      }
    }
    setTimeout(() => this.setLoading(false), 200);
  }

  public updateNotes(id: string): void {
    this.notes = this.notes.filter((note) => {
      return note._id !== id;
    });
  }

  public async fetchActivityNotes(): Promise<void> {
    try {
      const res = await this.customerService.getCustomerActivities(
        this.selectedCustomerId
      );
      this.notes = res;
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof APIError) {
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }
  public update(updatedNotes: ActivitySchema[]): void {
    this.notes = updatedNotes;
  }

  public get customer(): CustomerSchema {
    return this.selectedCustomer;
  }

  protected get activityUpdate(): string | false {
    let update;
    if (this.notes.length < 1) {
      update = false;
    } else {
      const now = moment();
      const then = moment(this.notes[0].contacted_at);
      const difference = now.diff(then, "days");
      if (difference === 0) {
        update = "Less than a day ago";
      } else {
        update = difference + " days ago";
      }
    }
    return update;
  }
}
